import moment from "moment";

export const getQuestionFormName = id => `DIAGNOSTIC_${id}`;

export function convertBirthdayToAge(birthday) {
  return birthday ? moment().diff(birthday, "years") : null;
}

export function formatBirthdayForBackend(birthday) {
  return birthday ? moment(birthday).format("YYYY-MM-DD") : null;
}



// WEBPACK FOOTER //
// ./src/modules/diagnostic/diagnostic-utils.js